import { RawStoreData } from '@/lib/stores/store-types'

/**
 * Search location including coordinates and the country derived from the geocoder response.
 * The `country` field is used to filter stores by the country of the searched place,
 * not the user's locale — enabling cross-country searches (e.g. searching "London" from en-us).
 */
export interface SearchLocation {
	latitude: number
	longitude: number
	country?: string
}

/**
 * Fetches nearby stores from the API for a given location and radius.
 * Passes the geocoded country (if available) so the API filters stores by country.
 */
export async function fetchNearbyStores(location: SearchLocation, radius: number): Promise<RawStoreData[]> {
	const params = new URLSearchParams({
		lat: String(location.latitude),
		lng: String(location.longitude),
		radius: String(radius),
	})
	if (location.country) {
		params.set('country', location.country)
	}
	const response = await fetch(`/api/stores/nearby/?${params.toString()}`)
	const data = await response.json()
	return data.stores
}

export function downloadFile(blob: Blob, filename: string, contentType: string) {
	const link = document.createElement('a')
	link.href = URL.createObjectURL(blob)
	link.download = filename
	link.type = contentType
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	URL.revokeObjectURL(link.href)
}
